import React, { Component } from "react";
import "./CalendarBoard.css";
import i18next from "i18next";
import { ReactComponent as ArrowIcon } from "./../../img/icon/arrow.svg";

const MONTH_ENG = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "	December",
];

export default class CalendarBoard extends Component<any, any> {
  board: any;
  constructor(props: any) {
    super(props);

    this.board = React.createRef();
    this.state = {
      boxHeight: "auto",
    };
  }

  componentDidMount() {
    if (this.board.current) {
      let h = this.board.current.clientWidth / 8;
      this.setState({ boxHeight: h + "px" });
    }
  }

  componentWillReceiveProps(nextProps: any) { }

  selectDate = (date: Date) => (e: any) => {
    let render_m = new Date(this.props.month).getMonth();
    if (date.getMonth() === render_m) {
      if (this.props.onSelect) {
        this.props.onSelect(date);
      }
    }
  };

  renderCalendar() {
    let loop = new Date(this.props.month);
    let render_m = loop.getMonth();

    loop.setDate(1);
    while (loop.getDay() !== 0) {
      loop.setDate(loop.getDate() - 1);
    }

    let month = [];
    let today_d = new Date().getDate();
    let today_m = new Date().getMonth();

    do {
      let week = [];
      for (let i = 0; i < 7; i++) {
        let day = "";

        let c = "CalendarBoard-Day";
        if (
          render_m === this.props.select.getMonth() &&
          loop.getFullYear() === this.props.select.getFullYear() &&
          loop.getMonth() === this.props.select.getMonth() &&
          loop.getDate() === this.props.select.getDate()
        ) {
          if (this.props.mode == "LIST") c += " Select-none";
          else c += " Select";
        }
        if (render_m !== today_m) {
          if (loop.getMonth() === render_m) day = loop.getDate().toString();
        } else {
          if (loop.getMonth() === today_m) {
            if (loop.getDate() === today_d) {
              day = i18next.t("News.ECI.Today", "");
              c += " Today";
            } else {
              day = loop.getDate().toString();
            }
          }
        }

        let haveEvents: any = "";
        let event = (loop.getMonth() + 1).toString() + loop.getDate().toString()
        this.props.haveEvents.forEach((e: string) => {
          if (e == event && render_m == loop.getMonth()) {
            haveEvents = <div className="CalendarBoard-HasEvent"></div>
          }
        });

        week.push(
          <div
            className={c}
            style={{
              height: this.state.boxHeight,
              lineHeight: this.state.boxHeight,
            }}
            key={"CD" + i}
            onClick={this.selectDate(new Date(loop.getTime()))}
          >
            {day}
            {haveEvents}
          </div>
        );
        loop.setDate(loop.getDate() + 1);
      }

      month.push(
        <div key={"CW" + month.length} className="CalendarBoard-Week">
          {week}
        </div>
      );
    } while (loop.getMonth() === render_m);

    return month;
  }

  displayMonth() {
    if (this.props.month) {
      let d = this.props.month.split("-");
      if (i18next.language === "en") {
        return MONTH_ENG[parseInt(d[1]) - 1] + " " + d[0];
      } else {
        return d[0] + " 年 " + d[1] + " 月";
      }
    }
  }

  onPrev = (e: any) => {
    if (this.props.onPrev) this.props.onPrev();
  };

  onNext = (e: any) => {
    if (this.props.onNext) this.props.onNext();
  };

  renderPrevButton() {
    if (this.props.disablePrev == false) {
      if (this.props.month === this.props.min) {
        return (
          <div className="CalendarBoard-Control-Prev">
            <ArrowIcon
              style={{
                stroke: "#D3D3D3",
                height: "1em",
                display: "block",
                transform: "rotate(180deg)",
              }}
            ></ArrowIcon>
          </div>
        );
      } else {
        return (
          <div className="CalendarBoard-Control-Prev" onClick={this.onPrev}>
            <ArrowIcon
              style={{
                stroke: "#666666",
                height: "1em",
                display: "block",
                transform: "rotate(180deg)",
              }}
            ></ArrowIcon>
          </div>
        );
      }
    }
  }

  renderNextButton() {
    if (this.props.disableNext == false) {
      if (this.props.month === this.props.max) {
        return (
          <div className="CalendarBoard-Control-Next">
            <ArrowIcon
              style={{ stroke: "#D3D3D3", height: "1em", display: "block" }}
            ></ArrowIcon>
          </div>
        );
      } else {
        return (
          <div className="CalendarBoard-Control-Next" onClick={this.onNext}>
            <ArrowIcon
              style={{ stroke: "#666666", height: "1em", display: "block" }}
            ></ArrowIcon>
          </div>
        );
      }
    }
  }

  render() {
    return (
      <div
        className="CalendarBoard"
        ref={this.board}
        style={{ width: "350px", marginRight: "15px", marginLeft: "15px" }}
      >
        <div className="CalendarBoard-Control" style={{ marginBottom: "20px" }}>
          {this.renderPrevButton()}
          <div className="CalendarBoard-Control-Current">
            {this.displayMonth()}
          </div>
          {this.renderNextButton()}
        </div>
        <div
          className="CalendarBoard-Week"
          style={{ color: "#999999", fontSize: "100%" }}
        >
          <div className="CalendarBoard-Day">
            {i18next.t("News.ECI.Sun", "")}
          </div>
          <div className="CalendarBoard-Day">
            {i18next.t("News.ECI.Mon", "")}
          </div>
          <div className="CalendarBoard-Day">
            {i18next.t("News.ECI.Tue", "")}
          </div>
          <div className="CalendarBoard-Day">
            {i18next.t("News.ECI.Wed", "")}
          </div>
          <div className="CalendarBoard-Day">
            {i18next.t("News.ECI.Thu", "")}
          </div>
          <div className="CalendarBoard-Day">
            {i18next.t("News.ECI.Fri", "")}
          </div>
          <div className="CalendarBoard-Day">
            {i18next.t("News.ECI.Sat", "")}
          </div>
        </div>
        {this.renderCalendar()}
      </div>
    );
  }
}
